import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { EverriseLogo } from "./brandLogo"

const WindowIcon = ({ dark }) => {
  const fillColorClass = dark ? "text-white" : "text-link-blue"
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
      className={`fill-current ${fillColorClass}`}
    >
      <path d="M11.25 11.25V12.5H2.5C2.16848 12.5 1.85054 12.3683 1.61612 12.1339C1.3817 11.8995 1.25 11.5815 1.25 11.25V5H2.5V11.25M13.75 3.75V8.75C13.75 9.08152 13.6183 9.39946 13.3839 9.63388C13.1495 9.8683 12.8315 10 12.5 10H5C4.66848 10 4.35054 9.8683 4.11612 9.63388C3.8817 9.39946 3.75 9.08152 3.75 8.75V3.75C3.75 3.41848 3.8817 3.10054 4.11612 2.86612C4.35054 2.6317 4.66848 2.5 5 2.5H12.5C12.8315 2.5 13.1495 2.6317 13.3839 2.86612C13.6183 3.10054 13.75 3.41848 13.75 3.75ZM12.5 3.75H5V8.75H12.5V3.75Z" />
    </svg>
  )
}

const NavRIcon = ({ className }) => (
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className ? className : "fill-current text-link-blue"}`}
  >
    <path d="M8.76768 6.78615C8.59628 6.96943 8.5 7.21797 8.5 7.47712C8.5 7.73628 8.59628 7.98482 8.76768 8.1681L13.2932 13.0059L8.76768 17.8437C8.60114 18.028 8.50899 18.2749 8.51107 18.5312C8.51316 18.7874 8.60931 19.0325 8.77882 19.2137C8.94832 19.395 9.17763 19.4977 9.41734 19.5C9.65705 19.5022 9.888 19.4037 10.0604 19.2257L15.2323 13.6969C15.4037 13.5136 15.5 13.2651 15.5 13.0059C15.5 12.7467 15.4037 12.4982 15.2323 12.3149L10.0604 6.78615C9.88898 6.60293 9.65648 6.5 9.41405 6.5C9.17163 6.5 8.93913 6.60293 8.76768 6.78615Z" />
  </svg>
)

const LinkButton = ({ text, textSize, link, dark = false, noArrow = false, compact = false, external = false }) => {
  const paddingClasses = compact
    ? "px-1.5 py-1.5"
    : "px-6 py-4"
  const colorClasses = dark
    ? "border-brand bg-white hover:bg-brand text-brand hover:text-white"
    : "border-brand bg-brand hover:bg-white text-link-white hover:text-brand"
  const textSizeClasses = textSize === "small" ? "text-sp-nav-title lg:text-main-nav-title" : ""
  const childrenPaddingClasses = compact
    ? "pl-3"
    : "pl-8"
  const childrenColorClasses = dark
    ? "fill-current text-brand group-hover:text-white"
    : "fill-current text-white group-hover:text-brand"
  return (
    <Link to={link} target={`${external ? "_blank" : "_self"}`} className={`flex justify-center items-center text-center ${paddingClasses} group transition-colors duration-150 border ${colorClasses} font-bold ${compact && "text-sp-nav-title lg:text-main-base"}`}>
      <p className={`${!noArrow && `${childrenPaddingClasses}`} ${textSizeClasses}`}>{text}</p>
      {!noArrow && <div className={`${childrenPaddingClasses}`}><NavRIcon className={`transition-colors duration-150 ${childrenColorClasses}`} /></div>}
    </Link>
  )
}

const GlobalFooter = () => {
  return (
    <footer className={"px-6 lg:px-0 py-10 w-full flex justify-center bg-brand"}>
      <div className={"w-full max-w-content-regular space-y-12 !text-white text-main-footer-base"}>
        <div className={"lg:grid lg:grid-cols-2 lg:gap-x-12"}>
          <div className={"space-y-4"}>
            <EverriseLogo
              className={`h-[40px] w-[121px]`}
              innerClassName={"fill-current stroke-current text-white"}
            />
            <div>
              <a className={"text-sp-small lg:text-main-small underline"} href={"https://goo.gl/maps/UZLYZvyBP4sfEVwL8"}
                target={"_self"}>
                <p>〒 106-0032</p>
                <p>東京都港区六本木6-8-10 STEP六本木5F</p>
              </a>
            </div>
            <div className={"w-fit"}><LinkButton text={"お問合せ"} textSize={"small"} link={"https://www.ever-rise.co.jp/contact/"} dark={true}
              compact={true} external={false} /></div>
          </div>
          <div className={"mt-12 lg:mt-0 grid grid-cols-10 gap-x-2 lg:gap-x-6"}>
            <div className={"col-span-4 space-y-6"}>
              <div>
                <a href={"https://www.ever-rise.co.jp/services/"} className={"font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}>サービス</a>
                <div className={"flex flex-col space-y-2 mt-3"}>
                  <a href={"https://www.ever-rise.co.jp/services/consulting/"}>コンサルティング</a>
                  <a href={"https://www.ever-rise.co.jp/services/it/"}>技術支援・システム開発</a>
                  <a href={"https://www.ever-rise.co.jp/services/hr/"}>人材紹介・教育</a>
                </div>
              </div>
              <div>
                <a href={"https://www.ever-rise.co.jp/services/data-and-ai/"} className={"font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}>データ × AI</a>
              </div>
              <div>
                <a href={"https://www.ever-rise.co.jp/services/products/"}
                  className={"font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}>プロダクト</a>
                <div className={"space-y-2 mt-3"}>
                  <a href={`https://www.ever-rise.co.jp/integral-core/`}
                    target={"_self"}>
                    <p>INTEGRAL-CORE</p>
                  </a>
                  <a href={`https://www.ever-rise.co.jp/integral-core/bridgesignal/`} target={"_self"}>
                    <p>INTEGRAL-CORE BridgeSignal</p>
                  </a>
                  <a href={`https://www.ever-rise.co.jp/integral-core/jetjunction-ga4/`} target={"_self"}>
                    <p>INTEGRAL-CORE JetJunction</p>
                  </a>
                  <a href={`https://www.ever-rise.co.jp/admiral/`}
                    target={"_self"}>
                    <p>ADmiral</p>
                  </a>
                </div>
              </div>
            </div>
            <div className={"col-span-4 space-y-6"}>
              <div>
                <a href={"https://www.ever-rise.co.jp/solutions/"} className={"font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}>ソリューション</a>
              </div>
              <div>
                <a href={"https://www.ever-rise.co.jp/third-party-products/"}
                  className={"font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}>取り扱い製品</a>
              </div>
              <div>
                <a href={"https://www.ever-rise.co.jp/cases/"} className={"font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}>実績</a>
              </div>
              <div>
                <a className={"font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}
                  href={`https://www.ever-rise.co.jp/dx-blog/`} target={"_self"}>ブログ</a>
              </div>
            </div>
            <div className={"col-span-2 space-y-6"}>
              <div>
                <a href={"https://www.ever-rise.co.jp/company/"} className={"font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}>会社情報</a>
              </div>
              <div>
                <a className={"font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}
                  href={`https://www.ever-rise.co.jp/news/`} target={"_self"}>ニュース</a>
              </div>
              <div>
                <a className={"flex items-end space-x-2 font-bold text-sp-footer-navtitle lg:text-main-footer-navtitle"}
                  href={`https://www.ever-rise.co.jp/recruit/`} target={"_blank"}>
                  <p>採用</p>
                  <div><WindowIcon dark={true} /></div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={"lg:flex lg:justify-between h-auto w-full"}>
          <div className={"h-[40px] w-fit flex space-x-4 mb-6 lg:mb-0"}>
            <StaticImage height={40} className={"max-h-full w-auto"} objectFit={"contain"}
              src={"../images/Sponsor_APAC_Real.png"} alt="" loading={"eager"} placeholder={"none"} />
            <StaticImage height={40} className={"max-h-full w-auto"} objectFit={"contain"}
              src={"../images/aws_consulting_partner_badge.jpg"} alt="" loading={"eager"}
              placeholder={"none"} />
            <StaticImage height={40} className={"max-h-full w-auto"} objectFit={"contain"}
              src={"../images/partnership_eo.png"} alt="" loading={"eager"} placeholder={"none"} />
          </div>
          <div className={"flex items-end space-x-6 text-sp-footer-navtitle-small lg:text-main-footer-navtitle-small"}>
            <a href={"https://www.ever-rise.co.jp/privacy/"}>個人情報保護方針</a>
            <a href={"https://www.ever-rise.co.jp/security/"}>情報セキュリティ方針</a>
            <a href={"https://www.ever-rise.co.jp/sitemap/"}>サイトマップ</a>
          </div>
        </div>
        <div className={"text-center"}>
          <p>©EVERRISE CO.,LTD. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default GlobalFooter
